module.exports = __webpack_public_path__ + "static/webinar1_slides-b312a55729d248d2801906a917cc8db3.pdf";